import { Link } from "react-router-dom";
import { format } from "timeago.js";

const ClickHandler = () => {
  window.scrollTo(10, 0);
};

const BlogSidebar = ({ events, currentBlogs, blLeft, products }) => {
  const apiUrl = process.env.REACT_APP_PUBLIC_API_URL;

  const relatedPosts = events
    ? events
        .filter((event) => !currentBlogs.some((blog) => blog.id === event.id))
        .slice(0, 4)
    : [];

  const brandDark = "rgba(0, 0, 139, 0.8)"; // dark blue
  const brandLight = "#4da3ff"; // light blue

  return (
    <div className={`col col-lg-4 col-12 ${blLeft}`}>
      <div
        className="blog-sidebar"
        style={{
          border: `1px solid rgba(0, 0, 139, 0.2)`,
          borderRadius: "12px",
          padding: "25px",
          backgroundColor: "#fff",
          boxShadow: "0 4px 12px rgba(0, 0, 139, 0.1)",
        }}
      >
        <div className="widget recent-post-widget">
          <h3
            style={{
              color: brandDark,
              marginBottom: "20px",
              borderBottom: `2px solid ${brandLight}`,
              display: "inline-block",
              paddingBottom: "5px",
            }}
          >
            Related Events
          </h3>
          <div className="posts">
            {relatedPosts.map((blog, bl) => (
              <div
                key={bl}
                className="post"
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "18px",
                  border: `1px solid rgba(0, 0, 139, 0.15)`,
                  borderRadius: "10px",
                  padding: "10px",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow =
                    "0 6px 15px rgba(0, 0, 139, 0.25)";
                  e.currentTarget.style.border = `1px solid rgba(0, 0, 139, 0.4)`;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = "none";
                  e.currentTarget.style.border = `1px solid rgba(0, 0, 139, 0.15)`;
                }}
              >
                <div
                  className="img-holder"
                  style={{
                    width: "30%",
                    height: "75px",
                    border: `1px solid rgba(0, 0, 139, 0.2)`,
                    borderRadius: "10px",
                    marginRight: "12px",
                    overflow: "hidden",
                  }}
                >
                  <img
                    src={`${apiUrl}/storage/${blog.banner}`}
                    alt={blog.eventName}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      display: "block",
                    }}
                  />
                </div>
                <div className="details" style={{ width: "70%" }}>
                  <h4 style={{ margin: "0 0 5px 0", fontSize: "16px" }}>
                    <Link
                      onClick={ClickHandler}
                      to={`/event-single/${blog.id}`}
                      style={{
                        color: "#000",
                        textDecoration: "none",
                        transition: "color 0.3s ease",
                      }}
                      onMouseEnter={(e) => (e.target.style.color = brandLight)}
                      onMouseLeave={(e) => (e.target.style.color = "#000")}
                    >
                      {blog.eventName}
                    </Link>
                  </h4>
                  <span
                    className="date"
                    style={{
                      fontSize: "13px",
                      color: "rgba(0,0,0,0.6)",
                    }}
                  >
                    {format(blog.created_at)}
                  </span>
                </div>
              </div>
            ))}

            {relatedPosts.length > 4 && (
              <div
                style={{
                  paddingLeft: "40%",
                  fontSize: "1.2rem",
                  color: brandLight,
                }}
              >
                …
              </div>
            )}
          </div>
        </div>
      </div>

      <div
        className="blog-sidebar"
        style={{
          border: `1px solid rgba(0, 0, 139, 0.2)`,
          borderRadius: "12px",
          padding: "25px",
          backgroundColor: "#fff",
          boxShadow: "0 4px 12px rgba(0, 0, 139, 0.1)",
        }}
      >
        <div className="widget recent-post-widget">
          <h3
            style={{
              color: brandDark,
              marginBottom: "20px",
              borderBottom: `2px solid ${brandLight}`,
              display: "inline-block",
              paddingBottom: "5px",
            }}
          >
            Our Products
          </h3>
          <div className="posts">
            {products.slice(0, 5).map((product, bl) => (
              <div
                key={bl}
                className="post"
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "18px",
                  border: `1px solid rgba(0, 0, 139, 0.15)`,
                  borderRadius: "10px",
                  padding: "10px",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow =
                    "0 6px 15px rgba(0, 0, 139, 0.25)";
                  e.currentTarget.style.border = `1px solid rgba(0, 0, 139, 0.4)`;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = "none";
                  e.currentTarget.style.border = `1px solid rgba(0, 0, 139, 0.15)`;
                }}
              >
                <div
                  className="img-holder"
                  style={{
                    width: "30%",
                    height: "75px",
                    border: `1px solid rgba(0, 0, 139, 0.2)`,
                    borderRadius: "10px",
                    marginRight: "12px",
                    overflow: "hidden",
                  }}
                >
                  <img
                    src={`${apiUrl}/storage/${product.banner}`}
                    alt={product.title}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      display: "block",
                    }}
                  />
                </div>
                <div className="details" style={{ width: "70%" }}>
                  <h4 style={{ margin: "0 0 5px 0", fontSize: "16px" }}>
                    <Link
                      onClick={ClickHandler}
                      to={`/product-single/${product.id}`}
                      style={{
                        color: "#000",
                        textDecoration: "none",
                        transition: "color 0.3s ease",
                      }}
                      onMouseEnter={(e) => (e.target.style.color = brandLight)}
                      onMouseLeave={(e) => (e.target.style.color = "#000")}
                    >
                      {product.title}
                    </Link>
                  </h4>
                  <span
                    className="date"
                    style={{
                      fontSize: "13px",
                      color: "rgba(0,0,0,0.6)",
                    }}
                  >
                    {format(product.created_at)}
                  </span>
                </div>
              </div>
            ))}

            {relatedPosts.length > 4 && (
              <div
                style={{
                  paddingLeft: "40%",
                  fontSize: "1.2rem",
                  color: brandLight,
                }}
              >
                …
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogSidebar;
